/**
 * plaudit.Stopwatch
 * This is a pausable stopwatch which calls a function each time the time elapses.
 *
 * Dependencies:
 *  - jQuery
 */
// TODO: Change to a listener framework (e.g. addListener) so multiple "onLap" can exist.
// TODO: Add an "on progress" and "on pause" listeners (how often would this call though? Example use would be a progress bar that shows time remaining until next slide progression.
// TODO: Add "getTimeRemaining" function.
!(function($){
	"use strict";
	var plaudit		= window.plaudit || {}
		,className	= "Stopwatch"		// TODO: Rename to "plaudit.Interval"? If so, every instance of "lap" should change to "interval" (basically).
		,clazz		= null
		,defaults = {
			lapTime: 1000				// Length of each lap in milliseconds
			,onLap: null				// Function to be called each lap. Can stop by returning false.
		};

	clazz = plaudit[className] = function( options ) {
		var self			= this
			,settings		= self.settings = $.extend( {}, defaults, options )
			,timeoutId		= null
			,lastLapTime	= null
			,isPaused		= false;

		function onLap() {
			if ( isRunning() ) {
				if ( settings.onLap.apply( self ) !== false ) {
					lastLapTime = (new Date()).getTime();
					startNextLap( settings.lapTime );
				} else {
					stop();
				}
			}
		}

		function startNextLap( timeToNextLap ) {
			isPaused = false;
			timeoutId = setTimeout( onLap, timeToNextLap );
		}

		function start( resetTimer ) {
			if ( !!resetTimer ) { // Default resetTimer to false.
				lastLapTime = null;
			}
			if ( timeoutId !== null ) {
				clearTimeout( timeoutId );
				timeoutId = null;
			}

			var timeToNextLap = null;
			if( lastLapTime !== null ) {
				var diff = (new Date()).getTime() - lastLapTime;
				timeToNextLap = Math.max( 0, settings.lapTime - diff);
			} else {
				timeToNextLap = settings.lapTime;
			}

			startNextLap( timeToNextLap );
		};

		function pause() {
			if ( timeoutId !== null ) {
				clearTimeout( timeoutId );
				timeoutId = null;
				isPaused = true;
				return true;
			}
			return false; // There was nothing to pause.
		};
		function resume() {
			if ( isPaused === true ) {
				start();
			}
		};

		function isRunning() {
			return timeoutId !== null;
		};

		function stop() {
			if ( timeoutId !== null ) {
				clearTimeout( timeoutId );
				timeoutId = null;
			}
			lastLapTime = null;
		};

		function setLapTime( newLapTime ) {
			settings.lapTime = newLapTime;
			if ( timeoutId !== null ) {
				start(); // Will calculate the new time remaining.
			}
		}

		// == Public ==
		self.start			= start;
		self.pause			= pause;
		self.resume			= resume;	// Same as start() but only starts if the timer was paused (via pause()).
		self.isRunning		= isRunning;
		self.stop			= stop;
		self.setLapTime		= setLapTime;
	};
	clazz.defaults = defaults; // Make the defaults public
})(jQuery);
